import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../baseComponent.js";
import InternalEvent from "../../core/constants/internalEvent.js";
import ProfileTabs from "./tab/profileTabs.jsx";
import SubscriptionActivityTrendAnalysis from "./analysis/subscriptionActivityTrend.jsx";
import CostUtilizationAnalysis from "./analysis/costUtilizationAnalysis.jsx";
import APIKeyManagement from "./api-key-management/apiKeyManagement.jsx";
import AccountSettings from "./account/accountSettings.jsx";
import PasswordChange from "./account/passwordChange.jsx";
import styles from "./profile.scss";

export default class Profile extends BaseComponent {
  constructor(props) {
    super(props);

  }

  componentWillMount() {
    this.publish(InternalEvent.App.ROUTER_TRANSITION_COMPLETED, "profile");
    this.tabs = [{
      id: 0,
      title: "Account Settings",
      activated: true
    }, {
      id: 1,
      title: "Password Change"
    }, {
      id: 2,
      title: "Subscription Activity Trend Analysis"
    }, {
      id: 3,
      title: "Cost & Utilization Analysis"
    },
    {
      id: 4,
      title: "API Key Management"
    }];
  }

  componentDidMount() {
    this.onTabChange(0);
  }

  onTabChange(tabId) {
    this.publish(InternalEvent.App.SHOW_PRELOADER);
    ReactDOM.unmountComponentAtNode(document.getElementById("profile-body-placeholder"));
    if (tabId === 0) {
      ReactDOM.render(React.createElement(AccountSettings),
        document.getElementById("profile-body-placeholder"));
    } else if (tabId == 1) {
      ReactDOM.render(React.createElement(PasswordChange),
        document.getElementById("profile-body-placeholder"));
    } else if (tabId == 2) {
      ReactDOM.render(React.createElement(SubscriptionActivityTrendAnalysis),
        document.getElementById("profile-body-placeholder"));
    }
    else if (tabId == 3) {
      ReactDOM.render(React.createElement(CostUtilizationAnalysis),
        document.getElementById("profile-body-placeholder"));
    } else {
      ReactDOM.render(React.createElement(APIKeyManagement),
        document.getElementById("profile-body-placeholder"));
    }
    setTimeout(() => {
      this.publish(InternalEvent.App.HIDE_PRELOADER);
    }, 700);
  }

  render() {
    return (
      <div className={styles.container}>
        <ProfileTabs tabs={this.tabs} onTabChange={this.onTabChange} />
        <div style={{ display: "flex", flex: "1", overflowX: "auto" }}>
          <div id="profile-body-placeholder">
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/profile.jsx